import {defineSlotRecipe} from '@chakra-ui/react3'

/**
 * recipe for CopyOnly:
 * variants:
 *  - alignment: left | center | right
 */

export default defineSlotRecipe({
    slots: ['root', 'buttonGroup'],
    base: {
        root: {
            display: 'flex',
            flexDirection: 'column',
            gap: 4
        },
        buttonGroup: {paddingTop: {base: 'spacing-8', s: 'spacing-16'}}
    },
    variants: {
        alignment: {
            left: {
                root: {alignItems: 'flex-start'},
                buttonGroup: {justifyContent: 'flex-start'}
            },
            center: {
                root: {alignItems: 'center'},
                buttonGroup: {justifyContent: 'center'}
            }
        }
    },
    defaultVariants: {
        alignment: 'left'
    }
})
